import React, { useCallback, useState } from 'react';
import cx from 'clsx';

import { IAnswerResponse } from '../../../api/types';
import { ExtendedAnswer } from '../../Chat/Message/Enhanced/ToolCallResults/types';

import { AnswerActions } from './Actions/Actions';
import { AnswerWrapper } from './AnswerWrapper/AnswerWrapper';
import { AnswerDescription } from './Description/Description';
import { AnswerIcon } from './Icon/Icon';
import { AnswerTopBar } from './TopBar/TopBar';

import styles from './Answer.module.scss';

export type AnswerChatCardProps = {
    answer: ExtendedAnswer;
    onClick: (answer: IAnswerResponse) => void;
};

const AnswerChatCardComponent: React.FC<AnswerChatCardProps> = ({ answer, onClick }) => {
    const [actionsRendered, setActionsRendered] = useState(false);

    const handleOnMouseOver = useCallback(() => {
        if (!actionsRendered) {
            setActionsRendered(true);
        }
    }, [actionsRendered]);

    const handleClick = useCallback(() => {
        onClick(answer);
    }, [answer, onClick]);

    return (
        <AnswerWrapper disableManuallyTrackingFocus answerUuid={answer.uuid} onMouseOver={handleOnMouseOver}>
            <AnswerTopBar queries={answer?.queries} documentMetadata={answer.document_metadata} />
            <AnswerDescription answer={answer} onClick={handleClick} />
            <div className={cx(styles.footer)}>
                <AnswerIcon answer={answer} onClick={handleClick} />
                {actionsRendered && <AnswerActions answer={answer} />}
            </div>
        </AnswerWrapper>
    );
};

export const AnswerChatCard = React.memo(AnswerChatCardComponent);
